import { Address } from '@cinch-labs/sites-sdk'

export const formatSiteAddress = (address: Address) =>
  [
    address.companyName,
    address.addressLine1,
    address.addressLine2,
    address.city,
    address.county,
    address.postcode.replace(/^(.*)(\d)/, '$1 $2'),
  ]
    .filter((x) => typeof x === 'string' && x.length > 0)
    .join(', ')
